import React from 'react';
import { useLocation } from 'react-router-dom';
import apiRequest from '../admin/services/apiClient';

const VisitTracker = () => {
    const location = useLocation();

    React.useEffect(() => {
        if (location.pathname.indexOf('/admin') === 0 || location.pathname === '/not-found') return;
        apiRequest('/visit.php', {
            method: 'POST',
            body: JSON.stringify({ page: `${location.pathname}${location.hash || ''}` }),
        }).catch(() => undefined);
    }, [location.pathname, location.hash]);

    return null;
};

export default VisitTracker;
